var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJournalIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "black",
    viewBox: "0 0 14 15",
    className: "transition-colors duration-300 fill-white",
    width: 14,
    height: 14,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#uCalendarAlt_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 11.153a.583.583 0 1 0 0-1.166.583.583 0 0 0 0 1.166Zm2.917 0a.583.583 0 1 0 0-1.167.583.583 0 0 0 0 1.167Zm0-2.333a.583.583 0 1 0 0-1.167.583.583 0 0 0 0 1.167ZM7 8.82a.583.583 0 1 0 0-1.167.583.583 0 0 0 0 1.167Zm4.084-7H10.5v-.583a.583.583 0 1 0-1.166 0v.583H4.667v-.583a.583.583 0 0 0-1.167 0v.583h-.583a1.75 1.75 0 0 0-1.75 1.75v8.167a1.75 1.75 0 0 0 1.75 1.75h8.167a1.75 1.75 0 0 0 1.75-1.75V3.57a1.75 1.75 0 0 0-1.75-1.75Zm.583 9.917a.583.583 0 0 1-.583.583H2.917a.583.583 0 0 1-.583-.583v-5.25h9.333v5.25Zm0-6.417H2.334V3.57a.583.583 0 0 1 .583-.583H3.5v.583a.583.583 0 1 0 1.167 0v-.583h4.667v.583a.583.583 0 0 0 1.166 0v-.583h.584a.583.583 0 0 1 .583.583v1.75Zm-7.583 3.5a.583.583 0 1 0 0-1.167.583.583 0 0 0 0 1.167Zm0 2.333a.583.583 0 1 0 0-1.166.583.583 0 0 0 0 1.166Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "uCalendarAlt_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 .07h14v14H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJournalIcon);
export default __webpack_public_path__ + "static/media/journalIcon.1951c782becf96d25958eb2e9c996670.svg";
export { ForwardRef as ReactComponent };